import { ModuleWithProviders, NgModule } from '@angular/core';
import { CBConfigService } from '@core/services/config/config.service';
import { CB_APP_CONFIG } from '@core/services/config/config.constants';

@NgModule()
export class CBConfigModule
{
    /**
     * Constructor
     */
    constructor(private _bxConfigService: CBConfigService)
    {
    }

    /**
     * forRoot method for setting user configuration
     *
     * @param config
     */
    static forRoot(config: any): ModuleWithProviders<CBConfigModule>
    {
        return {
            ngModule : CBConfigModule,
            providers: [
                {
                    provide : CB_APP_CONFIG,
                    useValue: config
                }
            ]
        };
    }
}
